import React from 'react';

import Base from './Base.jsx';

import CheckoutDurationSelectorWebinar from '../Components/CheckoutDurationSelectorWebinar/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-checkout-duration-selector-webinar';
  }

  renderElement(element) {
    var current = element.dataset.current;
    var currency = element.dataset.currency;
    var group = JSON.parse(element.dataset.group);


    return (
      <CheckoutDurationSelectorWebinar
        current={current}
        currency={currency}
        group={group}
      />
    );
  }
}


export default EntryPoint;
